import { BaseRequestModel } from "../BaseModel/BaseRequestModel";
import { PaginationModel } from "../pagination-model";

export class GetProDetailRequestModel extends BaseRequestModel{
    PlanID?:string
    PlanName?:string
    DepartmentName?:string
    SortOrder?:string
    Pagination:PaginationModel
}